// extracted by mini-css-extract-plugin
module.exports = {"FooterInfo":"FooterInfo_FooterInfo__1LKiT"};